(function () {
    'use strict';

    angular
        .module('wsl.notification')
        .provider('notificationHelper', notificationHelperProvider);

  //  notificationHelperProvider.$inject = [''];

    /* @ngInject */
    function notificationHelperProvider() {
        this.$get = NotificationHelper;

        function NotificationHelper() {
            var service = {
                notify: notify
            };

            return service;

            function notify(title, body, tag, icon) {
                var options = {
                    body: body,
                    icon: icon,
                    dir : 'ltr',
                    language: 'ru',
                    lang: 'ru',
                    tag: tag
                };

                var Notification = window.Notification || window.mozNotification || window.webkitNotification;
                var notification = false;

                // Let's check if the browser supports notifications
                if (!('Notification' in window)) {
                    //  alert("This browser does not support desktop notification");
                }

                // Let's check if the user is okay to get some notification
                else if (Notification.permission === 'granted') {
                    // If it's okay let's create a notification
                    notification = new Notification(title,options);
                }

                // Otherwise, we need to ask the user for permission
                // Note, Chrome does not implement the permission static property
                // So we have to check for NOT 'denied' instead of 'default'
                else if (Notification.permission !== 'denied') {
                    Notification.requestPermission(function (permission) {
                        // Whatever the user answers, we make sure we store the information
                        if (!('permission' in Notification)) {
                            Notification.permission = permission;
                        }

                        // If the user is okay, let's create a notification
                        if (permission === 'granted') {
                            notification = new Notification(title,options);
                        }
                    });
                }

                // At last, if the user already denied any notification, and you
                // want to be respectful there is no need to bother them any more.
                return notification;
            }
        }
    }
})();
